import React, { CSSProperties } from 'react';
import { Row, Col } from 'antd';
import { Entry } from 'contentful';
import { ContentSection, DisplayTextAlignment } from 'types/Content';
// @ts-ignore
import ReactMarkdown from 'react-markdown/with-html';
import ArrowLink from 'components/ArrowLink';
import { useTranslation } from 'react-i18next';

interface ContentProps {
  section: Entry<ContentSection>;
  reading?: boolean;
}

export default function ContentBlock({ section, reading }: ContentProps) {
  const {
    displayTextOnThe,
    title,
    body,
    image,
    linkUrl,
    backgroundColour,
    additionalHtml,
    additionalScripts
  } = section.fields;

  const { LEFT, RIGHT, CENTRE } = DisplayTextAlignment;

  const { t } = useTranslation()

  const styles: { [key: string]: CSSProperties } = {
    readMore: {
      fontSize: '16px',
      marginTop: '0.5em'
    }
  };

  const headerRenderers = {
    paragraph: (props: { className: string; children: any }) => (
      <h2
        className={displayTextOnThe !== CENTRE ? 'th-left' : 'th-centre'}
        style={{
          lineHeight: '50px'
        }}
      >
        {props.children}
      </h2>
    )
  };

  const renderText = (): JSX.Element => {
    return (
      <div style={{ marginTop: '40px' }}>
        <ReactMarkdown
          escapeHtml={false}
          source={title}
          renderers={headerRenderers}
        />
        {body && (
          <>
            <ReactMarkdown
              className={displayTextOnThe !== CENTRE ? 'th-left' : 'th-centre'}
              source={body}
            />
            {linkUrl && (
              <ArrowLink
                linkUrl={linkUrl}
                text={t("Read More")}
                style={styles.readMore}
              />
            )}
          </>
        )}
      </div>
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <div style={{ marginTop: '40px' }}>
        {image && (
          <img
            style={{ maxWidth: '300px', maxHeight: '300px' }}
            src={image.fields.file.url}
            alt=""
          />
        )}
      </div>
    );
  };

  const renderAdditionalHtml = (html: string) => {
    return (
      <div style={{ width: '100%' }}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    );
  };

  const renderAdditionalScripts = (scripts: string) => {
    // eslint-disable-next-line
    return eval(scripts);
  };

  return (
    <Row
      type="flex"
      style={{
        backgroundColor: backgroundColour ? backgroundColour : undefined,
        paddingTop: '10px',
        paddingBottom: '25px'
      }}
    >
      {displayTextOnThe === CENTRE || reading ? (
        <Col
          lg={{ offset: reading ? 4 : 3, span: reading ? 16 : 18 }}
          xs={{ offset: 1, span: 22 }}
          style={{
            justifyContent: 'center',
            display: 'flex',
            marginTop: '20px'
          }}
        >
          {renderText()}
        </Col>
      ) : (
        <>
          <Col
            lg={{ offset: 3, span: displayTextOnThe === RIGHT ? 6 : 9 }}
            xs={{ span: 22, order: 1, offset: 1 }}
            className="th-bottom-space"
          >
            {displayTextOnThe === LEFT ? renderText() : renderImage()}
          </Col>
          <Col
            lg={9}
            xs={{ span: 22, order: 2, offset: 1 }}
            className="th-bottom-space"
          >
            {displayTextOnThe === RIGHT ? renderText() : renderImage()}
          </Col>
        </>
      )}
      {additionalHtml && renderAdditionalHtml(additionalHtml)}
      {additionalScripts && renderAdditionalScripts(additionalScripts)}
    </Row>
  );
}
